/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrucksRouteImport } from './routes/trucks'
import { Route as TrackRouteImport } from './routes/track'
import { Route as TollPlazasRouteImport } from './routes/toll-plazas'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PartiesRouteImport } from './routes/parties'
import { Route as MaterialsRouteImport } from './routes/materials'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DriversRouteImport } from './routes/drivers'
import { Route as CompanyProfileRouteImport } from './routes/company-profile'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LorryHireChallansIndexRouteImport } from './routes/lorry-hire-challans.index'
import { Route as LoadingSlipsIndexRouteImport } from './routes/loading-slips.index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices.index'
import { Route as BiltyIndexRouteImport } from './routes/bilty.index'
import { Route as ToolsCashBookRouteImport } from './routes/tools.cash-book'
import { Route as SettingsWhatsappRouteImport } from './routes/settings.whatsapp'
import { Route as ReportsOutstandingRouteImport } from './routes/reports.outstanding'
import { Route as ReportsLedgerVendorRouteImport } from './routes/reports.ledger-vendor'
import { Route as ReportsLedgerPartyRouteImport } from './routes/reports.ledger-party'
import { Route as ReportsGstRouteImport } from './routes/reports.gst'
import { Route as ReportsBranchPlRouteImport } from './routes/reports.branch-pl'
import { Route as ReportsBilty360RouteImport } from './routes/reports.bilty-360'
import { Route as PaymentsReceiptsRouteImport } from './routes/payments.receipts'
import { Route as LorryHireChallansNewRouteImport } from './routes/lorry-hire-challans.new'
import { Route as LorryHireChallansIdRouteImport } from './routes/lorry-hire-challans.$id'
import { Route as LoadingSlipsNewRouteImport } from './routes/loading-slips.new'
import { Route as LoadingSlipsIdRouteImport } from './routes/loading-slips.$id'
import { Route as InvoicesNewRouteImport } from './routes/invoices.new'
import { Route as InvoicesIdRouteImport } from './routes/invoices.$id'
import { Route as BiltyNewRouteImport } from './routes/bilty.new'
import { Route as BiltyIdRouteImport } from './routes/bilty.$id'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as ToolsManualTaxInvoicesIndexRouteImport } from './routes/tools.manual-tax-invoices.index'
import { Route as ToolsManualTaxInvoicesNewRouteImport } from './routes/tools.manual-tax-invoices.new'
import { Route as ToolsManualTaxInvoicesIdRouteImport } from './routes/tools.manual-tax-invoices.$id'
import { Route as BiltyIdEditRouteImport } from './routes/bilty.$id_.edit'
import { Route as ToolsManualTaxInvoicesIdEditRouteImport } from './routes/tools.manual-tax-invoices.$id_.edit'

const TrucksRoute = TrucksRouteImport.update({
  id: '/trucks',
  path: '/trucks',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackRoute = TrackRouteImport.update({
  id: '/track',
  path: '/track',
  getParentRoute: () => rootRouteImport,
} as any)
const TollPlazasRoute = TollPlazasRouteImport.update({
  id: '/toll-plazas',
  path: '/toll-plazas',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PartiesRoute = PartiesRouteImport.update({
  id: '/parties',
  path: '/parties',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsRoute = MaterialsRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DriversRoute = DriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyProfileRoute = CompanyProfileRouteImport.update({
  id: '/company-profile',
  path: '/company-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LorryHireChallansIndexRoute = LorryHireChallansIndexRouteImport.update({
  id: '/lorry-hire-challans/',
  path: '/lorry-hire-challans/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoadingSlipsIndexRoute = LoadingSlipsIndexRouteImport.update({
  id: '/loading-slips/',
  path: '/loading-slips/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const BiltyIndexRoute = BiltyIndexRouteImport.update({
  id: '/bilty/',
  path: '/bilty/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsCashBookRoute = ToolsCashBookRouteImport.update({
  id: '/tools/cash-book',
  path: '/tools/cash-book',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWhatsappRoute = SettingsWhatsappRouteImport.update({
  id: '/settings/whatsapp',
  path: '/settings/whatsapp',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsOutstandingRoute = ReportsOutstandingRouteImport.update({
  id: '/reports/outstanding',
  path: '/reports/outstanding',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsLedgerVendorRoute = ReportsLedgerVendorRouteImport.update({
  id: '/reports/ledger-vendor',
  path: '/reports/ledger-vendor',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsLedgerPartyRoute = ReportsLedgerPartyRouteImport.update({
  id: '/reports/ledger-party',
  path: '/reports/ledger-party',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsGstRoute = ReportsGstRouteImport.update({
  id: '/reports/gst',
  path: '/reports/gst',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsBranchPlRoute = ReportsBranchPlRouteImport.update({
  id: '/reports/branch-pl',
  path: '/reports/branch-pl',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsBilty360Route = ReportsBilty360RouteImport.update({
  id: '/reports/bilty-360',
  path: '/reports/bilty-360',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsReceiptsRoute = PaymentsReceiptsRouteImport.update({
  id: '/payments/receipts',
  path: '/payments/receipts',
  getParentRoute: () => rootRouteImport,
} as any)
const LorryHireChallansNewRoute = LorryHireChallansNewRouteImport.update({
  id: '/lorry-hire-challans/new',
  path: '/lorry-hire-challans/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LorryHireChallansIdRoute = LorryHireChallansIdRouteImport.update({
  id: '/lorry-hire-challans/$id',
  path: '/lorry-hire-challans/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LoadingSlipsNewRoute = LoadingSlipsNewRouteImport.update({
  id: '/loading-slips/new',
  path: '/loading-slips/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LoadingSlipsIdRoute = LoadingSlipsIdRouteImport.update({
  id: '/loading-slips/$id',
  path: '/loading-slips/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIdRoute = InvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BiltyNewRoute = BiltyNewRouteImport.update({
  id: '/bilty/new',
  path: '/bilty/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BiltyIdRoute = BiltyIdRouteImport.update({
  id: '/bilty/$id',
  path: '/bilty/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsManualTaxInvoicesIndexRoute =
  ToolsManualTaxInvoicesIndexRouteImport.update({
    id: '/tools/manual-tax-invoices/',
    path: '/tools/manual-tax-invoices/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ToolsManualTaxInvoicesNewRoute =
  ToolsManualTaxInvoicesNewRouteImport.update({
    id: '/tools/manual-tax-invoices/new',
    path: '/tools/manual-tax-invoices/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const ToolsManualTaxInvoicesIdRoute =
  ToolsManualTaxInvoicesIdRouteImport.update({
    id: '/tools/manual-tax-invoices/$id',
    path: '/tools/manual-tax-invoices/$id',
    getParentRoute: () => rootRouteImport,
  } as any)
const BiltyIdEditRoute = BiltyIdEditRouteImport.update({
  id: '/bilty/$id_/edit',
  path: '/bilty/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsManualTaxInvoicesIdEditRoute =
  ToolsManualTaxInvoicesIdEditRouteImport.update({
    id: '/tools/manual-tax-invoices/$id_/edit',
    path: '/tools/manual-tax-invoices/$id/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/company-profile': typeof CompanyProfileRoute
  '/drivers': typeof DriversRoute
  '/login': typeof LoginRoute
  '/materials': typeof MaterialsRoute
  '/parties': typeof PartiesRoute
  '/profile': typeof ProfileRoute
  '/toll-plazas': typeof TollPlazasRoute
  '/track': typeof TrackRoute
  '/trucks': typeof TrucksRoute
  '/admin/users': typeof AdminUsersRoute
  '/bilty/$id': typeof BiltyIdRoute
  '/bilty/new': typeof BiltyNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/loading-slips/$id': typeof LoadingSlipsIdRoute
  '/loading-slips/new': typeof LoadingSlipsNewRoute
  '/lorry-hire-challans/$id': typeof LorryHireChallansIdRoute
  '/lorry-hire-challans/new': typeof LorryHireChallansNewRoute
  '/payments/receipts': typeof PaymentsReceiptsRoute
  '/reports/bilty-360': typeof ReportsBilty360Route
  '/reports/branch-pl': typeof ReportsBranchPlRoute
  '/reports/gst': typeof ReportsGstRoute
  '/reports/ledger-party': typeof ReportsLedgerPartyRoute
  '/reports/ledger-vendor': typeof ReportsLedgerVendorRoute
  '/reports/outstanding': typeof ReportsOutstandingRoute
  '/settings/whatsapp': typeof SettingsWhatsappRoute
  '/tools/cash-book': typeof ToolsCashBookRoute
  '/bilty/': typeof BiltyIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/loading-slips/': typeof LoadingSlipsIndexRoute
  '/lorry-hire-challans/': typeof LorryHireChallansIndexRoute
  '/bilty/$id/edit': typeof BiltyIdEditRoute
  '/tools/manual-tax-invoices/$id': typeof ToolsManualTaxInvoicesIdRoute
  '/tools/manual-tax-invoices/new': typeof ToolsManualTaxInvoicesNewRoute
  '/tools/manual-tax-invoices/': typeof ToolsManualTaxInvoicesIndexRoute
  '/tools/manual-tax-invoices/$id/edit': typeof ToolsManualTaxInvoicesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/company-profile': typeof CompanyProfileRoute
  '/drivers': typeof DriversRoute
  '/login': typeof LoginRoute
  '/materials': typeof MaterialsRoute
  '/parties': typeof PartiesRoute
  '/profile': typeof ProfileRoute
  '/toll-plazas': typeof TollPlazasRoute
  '/track': typeof TrackRoute
  '/trucks': typeof TrucksRoute
  '/admin/users': typeof AdminUsersRoute
  '/bilty/$id': typeof BiltyIdRoute
  '/bilty/new': typeof BiltyNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/loading-slips/$id': typeof LoadingSlipsIdRoute
  '/loading-slips/new': typeof LoadingSlipsNewRoute
  '/lorry-hire-challans/$id': typeof LorryHireChallansIdRoute
  '/lorry-hire-challans/new': typeof LorryHireChallansNewRoute
  '/payments/receipts': typeof PaymentsReceiptsRoute
  '/reports/bilty-360': typeof ReportsBilty360Route
  '/reports/branch-pl': typeof ReportsBranchPlRoute
  '/reports/gst': typeof ReportsGstRoute
  '/reports/ledger-party': typeof ReportsLedgerPartyRoute
  '/reports/ledger-vendor': typeof ReportsLedgerVendorRoute
  '/reports/outstanding': typeof ReportsOutstandingRoute
  '/settings/whatsapp': typeof SettingsWhatsappRoute
  '/tools/cash-book': typeof ToolsCashBookRoute
  '/bilty': typeof BiltyIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/loading-slips': typeof LoadingSlipsIndexRoute
  '/lorry-hire-challans': typeof LorryHireChallansIndexRoute
  '/bilty/$id/edit': typeof BiltyIdEditRoute
  '/tools/manual-tax-invoices/$id': typeof ToolsManualTaxInvoicesIdRoute
  '/tools/manual-tax-invoices/new': typeof ToolsManualTaxInvoicesNewRoute
  '/tools/manual-tax-invoices': typeof ToolsManualTaxInvoicesIndexRoute
  '/tools/manual-tax-invoices/$id/edit': typeof ToolsManualTaxInvoicesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/company-profile': typeof CompanyProfileRoute
  '/drivers': typeof DriversRoute
  '/login': typeof LoginRoute
  '/materials': typeof MaterialsRoute
  '/parties': typeof PartiesRoute
  '/profile': typeof ProfileRoute
  '/toll-plazas': typeof TollPlazasRoute
  '/track': typeof TrackRoute
  '/trucks': typeof TrucksRoute
  '/admin/users': typeof AdminUsersRoute
  '/bilty/$id': typeof BiltyIdRoute
  '/bilty/new': typeof BiltyNewRoute
  '/invoices/$id': typeof InvoicesIdRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/loading-slips/$id': typeof LoadingSlipsIdRoute
  '/loading-slips/new': typeof LoadingSlipsNewRoute
  '/lorry-hire-challans/$id': typeof LorryHireChallansIdRoute
  '/lorry-hire-challans/new': typeof LorryHireChallansNewRoute
  '/payments/receipts': typeof PaymentsReceiptsRoute
  '/reports/bilty-360': typeof ReportsBilty360Route
  '/reports/branch-pl': typeof ReportsBranchPlRoute
  '/reports/gst': typeof ReportsGstRoute
  '/reports/ledger-party': typeof ReportsLedgerPartyRoute
  '/reports/ledger-vendor': typeof ReportsLedgerVendorRoute
  '/reports/outstanding': typeof ReportsOutstandingRoute
  '/settings/whatsapp': typeof SettingsWhatsappRoute
  '/tools/cash-book': typeof ToolsCashBookRoute
  '/bilty/': typeof BiltyIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/loading-slips/': typeof LoadingSlipsIndexRoute
  '/lorry-hire-challans/': typeof LorryHireChallansIndexRoute
  '/bilty/$id_/edit': typeof BiltyIdEditRoute
  '/tools/manual-tax-invoices/$id': typeof ToolsManualTaxInvoicesIdRoute
  '/tools/manual-tax-invoices/new': typeof ToolsManualTaxInvoicesNewRoute
  '/tools/manual-tax-invoices/': typeof ToolsManualTaxInvoicesIndexRoute
  '/tools/manual-tax-invoices/$id_/edit': typeof ToolsManualTaxInvoicesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/company-profile'
    | '/drivers'
    | '/login'
    | '/materials'
    | '/parties'
    | '/profile'
    | '/toll-plazas'
    | '/track'
    | '/trucks'
    | '/admin/users'
    | '/bilty/$id'
    | '/bilty/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/loading-slips/$id'
    | '/loading-slips/new'
    | '/lorry-hire-challans/$id'
    | '/lorry-hire-challans/new'
    | '/payments/receipts'
    | '/reports/bilty-360'
    | '/reports/branch-pl'
    | '/reports/gst'
    | '/reports/ledger-party'
    | '/reports/ledger-vendor'
    | '/reports/outstanding'
    | '/settings/whatsapp'
    | '/tools/cash-book'
    | '/bilty/'
    | '/invoices/'
    | '/loading-slips/'
    | '/lorry-hire-challans/'
    | '/bilty/$id/edit'
    | '/tools/manual-tax-invoices/$id'
    | '/tools/manual-tax-invoices/new'
    | '/tools/manual-tax-invoices/'
    | '/tools/manual-tax-invoices/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/company-profile'
    | '/drivers'
    | '/login'
    | '/materials'
    | '/parties'
    | '/profile'
    | '/toll-plazas'
    | '/track'
    | '/trucks'
    | '/admin/users'
    | '/bilty/$id'
    | '/bilty/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/loading-slips/$id'
    | '/loading-slips/new'
    | '/lorry-hire-challans/$id'
    | '/lorry-hire-challans/new'
    | '/payments/receipts'
    | '/reports/bilty-360'
    | '/reports/branch-pl'
    | '/reports/gst'
    | '/reports/ledger-party'
    | '/reports/ledger-vendor'
    | '/reports/outstanding'
    | '/settings/whatsapp'
    | '/tools/cash-book'
    | '/bilty'
    | '/invoices'
    | '/loading-slips'
    | '/lorry-hire-challans'
    | '/bilty/$id/edit'
    | '/tools/manual-tax-invoices/$id'
    | '/tools/manual-tax-invoices/new'
    | '/tools/manual-tax-invoices'
    | '/tools/manual-tax-invoices/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/company-profile'
    | '/drivers'
    | '/login'
    | '/materials'
    | '/parties'
    | '/profile'
    | '/toll-plazas'
    | '/track'
    | '/trucks'
    | '/admin/users'
    | '/bilty/$id'
    | '/bilty/new'
    | '/invoices/$id'
    | '/invoices/new'
    | '/loading-slips/$id'
    | '/loading-slips/new'
    | '/lorry-hire-challans/$id'
    | '/lorry-hire-challans/new'
    | '/payments/receipts'
    | '/reports/bilty-360'
    | '/reports/branch-pl'
    | '/reports/gst'
    | '/reports/ledger-party'
    | '/reports/ledger-vendor'
    | '/reports/outstanding'
    | '/settings/whatsapp'
    | '/tools/cash-book'
    | '/bilty/'
    | '/invoices/'
    | '/loading-slips/'
    | '/lorry-hire-challans/'
    | '/bilty/$id_/edit'
    | '/tools/manual-tax-invoices/$id'
    | '/tools/manual-tax-invoices/new'
    | '/tools/manual-tax-invoices/'
    | '/tools/manual-tax-invoices/$id_/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CompanyProfileRoute: typeof CompanyProfileRoute
  DriversRoute: typeof DriversRoute
  LoginRoute: typeof LoginRoute
  MaterialsRoute: typeof MaterialsRoute
  PartiesRoute: typeof PartiesRoute
  ProfileRoute: typeof ProfileRoute
  TollPlazasRoute: typeof TollPlazasRoute
  TrackRoute: typeof TrackRoute
  TrucksRoute: typeof TrucksRoute
  AdminUsersRoute: typeof AdminUsersRoute
  BiltyIdRoute: typeof BiltyIdRoute
  BiltyNewRoute: typeof BiltyNewRoute
  InvoicesIdRoute: typeof InvoicesIdRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  LoadingSlipsIdRoute: typeof LoadingSlipsIdRoute
  LoadingSlipsNewRoute: typeof LoadingSlipsNewRoute
  LorryHireChallansIdRoute: typeof LorryHireChallansIdRoute
  LorryHireChallansNewRoute: typeof LorryHireChallansNewRoute
  PaymentsReceiptsRoute: typeof PaymentsReceiptsRoute
  ReportsBilty360Route: typeof ReportsBilty360Route
  ReportsBranchPlRoute: typeof ReportsBranchPlRoute
  ReportsGstRoute: typeof ReportsGstRoute
  ReportsLedgerPartyRoute: typeof ReportsLedgerPartyRoute
  ReportsLedgerVendorRoute: typeof ReportsLedgerVendorRoute
  ReportsOutstandingRoute: typeof ReportsOutstandingRoute
  SettingsWhatsappRoute: typeof SettingsWhatsappRoute
  ToolsCashBookRoute: typeof ToolsCashBookRoute
  BiltyIndexRoute: typeof BiltyIndexRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
  LoadingSlipsIndexRoute: typeof LoadingSlipsIndexRoute
  LorryHireChallansIndexRoute: typeof LorryHireChallansIndexRoute
  BiltyIdEditRoute: typeof BiltyIdEditRoute
  ToolsManualTaxInvoicesIdRoute: typeof ToolsManualTaxInvoicesIdRoute
  ToolsManualTaxInvoicesNewRoute: typeof ToolsManualTaxInvoicesNewRoute
  ToolsManualTaxInvoicesIndexRoute: typeof ToolsManualTaxInvoicesIndexRoute
  ToolsManualTaxInvoicesIdEditRoute: typeof ToolsManualTaxInvoicesIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trucks': {
      id: '/trucks'
      path: '/trucks'
      fullPath: '/trucks'
      preLoaderRoute: typeof TrucksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/track': {
      id: '/track'
      path: '/track'
      fullPath: '/track'
      preLoaderRoute: typeof TrackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/toll-plazas': {
      id: '/toll-plazas'
      path: '/toll-plazas'
      fullPath: '/toll-plazas'
      preLoaderRoute: typeof TollPlazasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parties': {
      id: '/parties'
      path: '/parties'
      fullPath: '/parties'
      preLoaderRoute: typeof PartiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials': {
      id: '/materials'
      path: '/materials'
      fullPath: '/materials'
      preLoaderRoute: typeof MaterialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drivers': {
      id: '/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof DriversRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company-profile': {
      id: '/company-profile'
      path: '/company-profile'
      fullPath: '/company-profile'
      preLoaderRoute: typeof CompanyProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lorry-hire-challans/': {
      id: '/lorry-hire-challans/'
      path: '/lorry-hire-challans'
      fullPath: '/lorry-hire-challans/'
      preLoaderRoute: typeof LorryHireChallansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loading-slips/': {
      id: '/loading-slips/'
      path: '/loading-slips'
      fullPath: '/loading-slips/'
      preLoaderRoute: typeof LoadingSlipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bilty/': {
      id: '/bilty/'
      path: '/bilty'
      fullPath: '/bilty/'
      preLoaderRoute: typeof BiltyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/cash-book': {
      id: '/tools/cash-book'
      path: '/tools/cash-book'
      fullPath: '/tools/cash-book'
      preLoaderRoute: typeof ToolsCashBookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/whatsapp': {
      id: '/settings/whatsapp'
      path: '/settings/whatsapp'
      fullPath: '/settings/whatsapp'
      preLoaderRoute: typeof SettingsWhatsappRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/outstanding': {
      id: '/reports/outstanding'
      path: '/reports/outstanding'
      fullPath: '/reports/outstanding'
      preLoaderRoute: typeof ReportsOutstandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/ledger-vendor': {
      id: '/reports/ledger-vendor'
      path: '/reports/ledger-vendor'
      fullPath: '/reports/ledger-vendor'
      preLoaderRoute: typeof ReportsLedgerVendorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/ledger-party': {
      id: '/reports/ledger-party'
      path: '/reports/ledger-party'
      fullPath: '/reports/ledger-party'
      preLoaderRoute: typeof ReportsLedgerPartyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/gst': {
      id: '/reports/gst'
      path: '/reports/gst'
      fullPath: '/reports/gst'
      preLoaderRoute: typeof ReportsGstRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/branch-pl': {
      id: '/reports/branch-pl'
      path: '/reports/branch-pl'
      fullPath: '/reports/branch-pl'
      preLoaderRoute: typeof ReportsBranchPlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/bilty-360': {
      id: '/reports/bilty-360'
      path: '/reports/bilty-360'
      fullPath: '/reports/bilty-360'
      preLoaderRoute: typeof ReportsBilty360RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/receipts': {
      id: '/payments/receipts'
      path: '/payments/receipts'
      fullPath: '/payments/receipts'
      preLoaderRoute: typeof PaymentsReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lorry-hire-challans/new': {
      id: '/lorry-hire-challans/new'
      path: '/lorry-hire-challans/new'
      fullPath: '/lorry-hire-challans/new'
      preLoaderRoute: typeof LorryHireChallansNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lorry-hire-challans/$id': {
      id: '/lorry-hire-challans/$id'
      path: '/lorry-hire-challans/$id'
      fullPath: '/lorry-hire-challans/$id'
      preLoaderRoute: typeof LorryHireChallansIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loading-slips/new': {
      id: '/loading-slips/new'
      path: '/loading-slips/new'
      fullPath: '/loading-slips/new'
      preLoaderRoute: typeof LoadingSlipsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loading-slips/$id': {
      id: '/loading-slips/$id'
      path: '/loading-slips/$id'
      fullPath: '/loading-slips/$id'
      preLoaderRoute: typeof LoadingSlipsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/new': {
      id: '/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/$id': {
      id: '/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof InvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bilty/new': {
      id: '/bilty/new'
      path: '/bilty/new'
      fullPath: '/bilty/new'
      preLoaderRoute: typeof BiltyNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bilty/$id': {
      id: '/bilty/$id'
      path: '/bilty/$id'
      fullPath: '/bilty/$id'
      preLoaderRoute: typeof BiltyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/manual-tax-invoices/': {
      id: '/tools/manual-tax-invoices/'
      path: '/tools/manual-tax-invoices'
      fullPath: '/tools/manual-tax-invoices/'
      preLoaderRoute: typeof ToolsManualTaxInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/manual-tax-invoices/new': {
      id: '/tools/manual-tax-invoices/new'
      path: '/tools/manual-tax-invoices/new'
      fullPath: '/tools/manual-tax-invoices/new'
      preLoaderRoute: typeof ToolsManualTaxInvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/manual-tax-invoices/$id': {
      id: '/tools/manual-tax-invoices/$id'
      path: '/tools/manual-tax-invoices/$id'
      fullPath: '/tools/manual-tax-invoices/$id'
      preLoaderRoute: typeof ToolsManualTaxInvoicesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bilty/$id_/edit': {
      id: '/bilty/$id_/edit'
      path: '/bilty/$id/edit'
      fullPath: '/bilty/$id/edit'
      preLoaderRoute: typeof BiltyIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/manual-tax-invoices/$id_/edit': {
      id: '/tools/manual-tax-invoices/$id_/edit'
      path: '/tools/manual-tax-invoices/$id/edit'
      fullPath: '/tools/manual-tax-invoices/$id/edit'
      preLoaderRoute: typeof ToolsManualTaxInvoicesIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CompanyProfileRoute: CompanyProfileRoute,
  DriversRoute: DriversRoute,
  LoginRoute: LoginRoute,
  MaterialsRoute: MaterialsRoute,
  PartiesRoute: PartiesRoute,
  ProfileRoute: ProfileRoute,
  TollPlazasRoute: TollPlazasRoute,
  TrackRoute: TrackRoute,
  TrucksRoute: TrucksRoute,
  AdminUsersRoute: AdminUsersRoute,
  BiltyIdRoute: BiltyIdRoute,
  BiltyNewRoute: BiltyNewRoute,
  InvoicesIdRoute: InvoicesIdRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  LoadingSlipsIdRoute: LoadingSlipsIdRoute,
  LoadingSlipsNewRoute: LoadingSlipsNewRoute,
  LorryHireChallansIdRoute: LorryHireChallansIdRoute,
  LorryHireChallansNewRoute: LorryHireChallansNewRoute,
  PaymentsReceiptsRoute: PaymentsReceiptsRoute,
  ReportsBilty360Route: ReportsBilty360Route,
  ReportsBranchPlRoute: ReportsBranchPlRoute,
  ReportsGstRoute: ReportsGstRoute,
  ReportsLedgerPartyRoute: ReportsLedgerPartyRoute,
  ReportsLedgerVendorRoute: ReportsLedgerVendorRoute,
  ReportsOutstandingRoute: ReportsOutstandingRoute,
  SettingsWhatsappRoute: SettingsWhatsappRoute,
  ToolsCashBookRoute: ToolsCashBookRoute,
  BiltyIndexRoute: BiltyIndexRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
  LoadingSlipsIndexRoute: LoadingSlipsIndexRoute,
  LorryHireChallansIndexRoute: LorryHireChallansIndexRoute,
  BiltyIdEditRoute: BiltyIdEditRoute,
  ToolsManualTaxInvoicesIdRoute: ToolsManualTaxInvoicesIdRoute,
  ToolsManualTaxInvoicesNewRoute: ToolsManualTaxInvoicesNewRoute,
  ToolsManualTaxInvoicesIndexRoute: ToolsManualTaxInvoicesIndexRoute,
  ToolsManualTaxInvoicesIdEditRoute: ToolsManualTaxInvoicesIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
